import type { ReactNode } from 'react';

import { cn } from '../lib/utils';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from './ui/dialog';

interface ModalProps {
  title: string;
  description?: string;
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  className?: string;
}

/**
 * Destructive confirmations and short forms only. Anything longer than four
 * fields belongs on its own route.
 */
export function Modal({ title, description, open, onClose, children, className }: ModalProps) {
  return (
    <Dialog open={open} onOpenChange={(next) => !next && onClose()}>
      {/* A dialog taller than the screen otherwise pushes its own buttons out
          of reach, with nothing to scroll: it is fixed and centred. */}
      <DialogContent
        className={cn('max-h-[calc(100dvh-2rem)] overflow-y-auto sm:max-w-md', className)}
      >
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {description ? <DialogDescription>{description}</DialogDescription> : null}
        </DialogHeader>

        {children}
      </DialogContent>
    </Dialog>
  );
}
